import * as Sentry from '@sentry/react';
import { MoveUpRight } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import errorIllustration from '../../assets/images/exclamation-mark.png';
import { Button } from '../../design-system/button/button';
import { Stack } from '../../design-system/stack/stack';

export const NoMatch = () => {
  const navigate = useNavigate();

  useEffect(() => {
    Sentry.captureMessage('Page not found', {
      level: 'warning',
    });
  }, []);

  return (
    <Stack space={4} align="center" className="mt-48">
      <Stack space={2} align="center">
        <div className="h-40 w-40">
          <img
            src={errorIllustration}
            alt=""
            loading="eager"
            fetchPriority="high"
            className="h-full w-full object-cover"
          />
        </div>

        <h2 className="text-center text-2xl font-medium">Page Not Found</h2>

        <p className="text-center text-base font-medium text-seapoint-gray-text">
          The page you're looking for doesn't exist or has been moved. Please check the URL or return to the homepage.
        </p>
      </Stack>

      <Button iconRight={<MoveUpRight />} onClick={() => navigate('/')}>
        Go to Homepage
      </Button>
    </Stack>
  );
};
